/**
 * The program's name, as agencies see it: the sidebar, page titles, the installed
 * app, e-mails and subscription invoices. Static files (index.html, the web app
 * manifest, offline.html) repeat it and change with it.
 */
export const PRODUCT_NAME = 'AcentePro';
